import { Search } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  onDiscover: () => void
  isLoading?: boolean
}

export function EmptyState({ onDiscover, isLoading }: EmptyStateProps) {
  // If loading, render a loading indicator instead of empty state
  if (isLoading) {
    return (
      <div className="w-full text-center py-8">
        <div className="flex items-center justify-center mb-3">
          <div className="w-12 h-12 rounded-full border-2 border-t-blue-500 border-r-transparent border-b-blue-300 border-l-transparent animate-spin" />
        </div>
        <p className="text-sm text-gray-500">Starting taxonomy discovery...</p>
        <p className="text-xs text-gray-400 mt-1">This may take a few seconds to initialize</p>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center py-24 px-4 text-center">
      {/* Icon */}
      <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-4">
        <Search className="w-8 h-8 text-blue-600" />
      </div>

      {/* Headline */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        No taxonomy discovered yet
      </h3>

      {/* Description */}
      <p className="text-sm text-gray-500 max-w-md mb-6">
        GenClair automatically discovers intents, tags, and entity types from your
        knowledge base documents using ML clustering and LLM labeling.
        Run the pipeline to generate your taxonomy.
      </p>

      {/* CTA button */}
      <Button
        onClick={onDiscover}
        disabled={isLoading}
        className="gap-2"
      >
        {isLoading ? (
          <>
            <span className="animate-spin">⏳</span> Starting…
          </>
        ) : (
          <>
            <Search className="w-4 h-4" /> Discover Taxonomy
          </>
        )}
      </Button>
    </div>
  )
}
